import DataLoadingFailed from "@entrilia/shared/components/DataLoadingFailed";
import InlineLoader from "@entrilia/shared/components/inlineLoader/InlineLoader";
import useFetch from "@entrilia/shared/hooks/useFetch";
import usePageTitle from "@entrilia/shared/hooks/usePageTitle";
import { logError } from "@entrilia/shared/logging";
import adminApi from "../../../api/adminApi";
import useClientContext from "../../../context/useClientContext";
import SnowflakeLogo from "../../../images/snowflake.png";
import IntegrationPageContainer from "../integration/IntegrationPageContainer";
import DwhConnectorTabs from "./DwhConnectorTabs";
import ResyncSection from "./ResyncSection";

const promotionText =
  "A single, global platform that powers the Data Cloud. Snowflake is uniquely designed to connect businesses globally, across any type or scale of data and many different workloads, and unlock seamless data collaboration.";

const SnowflakeConnectorPage = () => {
  usePageTitle("Snowflake");

  const { reportingPortalApp } = useClientContext();

  const [lastSyncResp, lastSyncFetchError] = useFetch(adminApi.getDwhLastSync);

  if (lastSyncFetchError) {
    logError(lastSyncFetchError.message || "getDwhLastSync failed", "SnowflakeConnectorPage");
    return <DataLoadingFailed title="Loading DWH sync info failed" />;
  }

  if (lastSyncResp === undefined) {
    return <InlineLoader />;
  }

  return (
    <IntegrationPageContainer
      title="Snowflake"
      logoSrc={SnowflakeLogo}
      overviewText={promotionText}
      appStatus={reportingPortalApp?.status}
      maxWidth="xl"
    >
      <ResyncSection lastSyncTime={lastSyncResp.endTime} />
      <DwhConnectorTabs />
    </IntegrationPageContainer>
  );
};

export default SnowflakeConnectorPage;
